/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { UserControllerGetProfileQueryResponse, UserControllerGetProfileQueryParams, UserControllerGetProfile400, UserControllerGetProfile401, UserControllerGetProfile403, UserControllerGetProfile404 } from "../../models/usersController/UserControllerGetProfile";

function getUserControllerGetProfileUrl() {
  const res = { method: 'GET', url: `/api/v1/users/me` as const }  
  return res
}

/**
 * @summary Get current user profile
 * {@link /api/v1/users/me}
 */
export async function userControllerGetProfile(params?: UserControllerGetProfileQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<UserControllerGetProfileQueryResponse, ResponseErrorConfig<UserControllerGetProfile400 | UserControllerGetProfile401 | UserControllerGetProfile403 | UserControllerGetProfile404>, unknown>({ method : "GET", url : getUserControllerGetProfileUrl().url.toString(), params, ... requestConfig })  
  return res.data
}